<div class="tags-section">
  <div class="tags-header">
    <h4>Tags</h4>
    <div class="search-container">
      <input
        type="text"
        [(ngModel)]="searchQuery"
        (input)="onSearchChange()"
        placeholder="Search tags..."
        class="tag-search-input"
      />
      <span class="search-icon">🔍</span>
    </div>
  </div>

  <div class="tags-content" *ngIf="video">
    <!-- Artists -->
    <div
      class="tag-category"
      *ngIf="hasTags('artist')"
    >
      <h5>{{ getCategoryLabel('artist') }}</h5>
      <div class="tags-list">
        <span
          *ngFor="let tag of filteredTags['artist']"
          [class]="'tag ' + tag.cssClass + ' clickable'"
          (click)="onTagClick(tag.name)"
          (keydown.enter)="onTagClick(tag.name)"
          (keydown.space)="onTagClick(tag.name)"
          [title]="'Click to search for: ' + tag.name"
          tabindex="0"
          role="button"
        >
          {{ tag.name }}
        </span>
      </div>
    </div>

    <!-- Characters -->
    <div
      class="tag-category"
      *ngIf="hasTags('character')"
    >
      <h5>{{ getCategoryLabel('character') }}</h5>
      <div class="tags-list">
        <span
          *ngFor="let tag of filteredTags['character']"
          [class]="'tag ' + tag.cssClass + ' clickable'"
          (click)="onTagClick(tag.name)"
          (keydown.enter)="onTagClick(tag.name)"
          (keydown.space)="onTagClick(tag.name)"
          [title]="'Click to search for: ' + tag.name"
          tabindex="0"
          role="button"
        >
          {{ tag.name }}
        </span>
      </div>
    </div>

    <!-- Species -->
    <div
      class="tag-category"
      *ngIf="hasTags('species')"
    >
      <h5>{{ getCategoryLabel('species') }}</h5>
      <div class="tags-list">
        <span
          *ngFor="let tag of filteredTags['species']"
          [class]="'tag ' + tag.cssClass + ' clickable'"
          (click)="onTagClick(tag.name)"
          (keydown.enter)="onTagClick(tag.name)"
          (keydown.space)="onTagClick(tag.name)"
          [title]="'Click to search for: ' + tag.name"
          tabindex="0"
          role="button"
        >
          {{ tag.name }}
        </span>
      </div>
    </div>

    <!-- Copyright -->
    <div
      class="tag-category"
      *ngIf="hasTags('copyright')"
    >
      <h5>{{ getCategoryLabel('copyright') }}</h5>
      <div class="tags-list">
        <span
          *ngFor="let tag of filteredTags['copyright']"
          [class]="'tag ' + tag.cssClass + ' clickable'"
          (click)="onTagClick(tag.name)"
          (keydown.enter)="onTagClick(tag.name)"
          (keydown.space)="onTagClick(tag.name)"
          [title]="'Click to search for: ' + tag.name"
          tabindex="0"
          role="button"
        >
          {{ tag.name }}
        </span>
      </div>
    </div>

    <!-- General Tags -->
    <div
      class="tag-category"
      *ngIf="hasTags('general')"
    >
      <h5>{{ getCategoryLabel('general') }}</h5>
      <div class="tags-list">
        <span
          *ngFor="let tag of filteredTags['general']"
          [class]="'tag ' + tag.cssClass + ' clickable'"
          (click)="onTagClick(tag.name)"
          (keydown.enter)="onTagClick(tag.name)"
          (keydown.space)="onTagClick(tag.name)"
          [title]="'Click to search for: ' + tag.name"
          tabindex="0"
          role="button"
        >
          {{ tag.name }}
        </span>
      </div>
    </div>

    <!-- Meta Tags -->
    <div
      class="tag-category"
      *ngIf="hasTags('meta')"
    >
      <h5>{{ getCategoryLabel('meta') }}</h5>
      <div class="tags-list">
        <span
          *ngFor="let tag of filteredTags['meta']"
          [class]="'tag ' + tag.cssClass + ' clickable'"
          (click)="onTagClick(tag.name)"
          (keydown.enter)="onTagClick(tag.name)"
          (keydown.space)="onTagClick(tag.name)"
          [title]="'Click to search for: ' + tag.name"
          tabindex="0"
          role="button"
        >
          {{ tag.name }}
        </span>
      </div>
    </div>

    <!-- Lore Tags -->
    <div
      class="tag-category"
      *ngIf="hasTags('lore')"
    >
      <h5>{{ getCategoryLabel('lore') }}</h5>
      <div class="tags-list">
        <span
          *ngFor="let tag of filteredTags['lore']"
          [class]="'tag ' + tag.cssClass + ' clickable'"
          (click)="onTagClick(tag.name)"
          (keydown.enter)="onTagClick(tag.name)"
          (keydown.space)="onTagClick(tag.name)"
          [title]="'Click to search for: ' + tag.name"
          tabindex="0"
          role="button"
        >
          {{ tag.name }}
        </span>
      </div>
    </div>
  </div>
</div>